
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute";

import Login from "./components/Login";
import CalendarView from "./components/CalendarView";
import ClienteForm from "./components/ClienteForm";
import CitaForm from "./components/CitaForm";
import GenerarMembrete from "./components/GenerarMembrete";
import Pagos from "./components/Pagos";
import Acompanantes from "./components/RegistrarAcompanante";
import Dashboard from "./components/Dashboard";
import Logout from "./components/Logout";
import DeudoresAlertConNotificacion from "./components/DeudoresAlertAvanzado";


function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta pública */}
        <Route path="/login" element={<Login />} />

        {/* Rutas privadas */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<CalendarView />} />
                  <Route path="/calendario" element={<CalendarView />} />
                  <Route path="/clientes" element={<ClienteForm />} />
                  <Route path="/citas" element={<CitaForm />} />
                  <Route path="/membrete" element={<GenerarMembrete />} />
                  <Route path="/pagos" element={<Pagos />} />
                  <Route path="/exportar" element={<Dashboard/>} />
                  <Route path="/acompanantes" element={<Acompanantes />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/logout" element={<Logout />} />
                  <Route path="/empresas" element={<DeudoresAlertConNotificacion />} />
                </Routes>
              </Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}


export default App;
